var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vue-import-tab" }, [
    _c("h3", { staticClass: "table-name" }, [
      _vm._v("Autoprovisioning Imports")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchQuery,
            expression: "searchQuery"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text", placeholder: "Search" },
        domProps: { value: _vm.searchQuery },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.searchQuery = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "filter-buttons" }, [
      _c(
        "button",
        {
          class: [
            "btn",
            "btn-sm",
            _vm.statusFilter === "all" ? "btn-primary" : "btn-default"
          ],
          on: {
            click: function($event) {
              _vm.statusFilter = "all"
            }
          }
        },
        [_vm._v("\n      All\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: [
            "btn",
            "btn-sm",
            _vm.statusFilter === "completed" ? "btn-primary" : "btn-default"
          ],
          on: {
            click: function($event) {
              _vm.statusFilter = "completed"
            }
          }
        },
        [_vm._v("\n      Completed\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: [
            "btn",
            "btn-sm",
            _vm.statusFilter === "incomplete" ? "btn-primary" : "btn-default"
          ],
          on: {
            click: function($event) {
              _vm.statusFilter = "incomplete"
            }
          }
        },
        [_vm._v("\n      Incomplete\n    ")]
      )
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center py-3" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
          _vm._v(" Loading autoprovisioning import data...\n  ")
        ])
      : _vm.error
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _vm._v("\n    " + _vm._s(_vm.error) + "\n  ")
        ])
      : _c("div", [
          _c("div", { staticClass: "table-responsive" }, [
            _c(
              "table",
              {
                staticClass:
                  "table table-striped table-hover autoprovisioning-table"
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        on: {
                          click: function($event) {
                            return _vm.sort("name")
                          }
                        }
                      },
                      [
                        _vm._v("\n              Domain Name\n              "),
                        _vm.sortKey === "name"
                          ? _c("span", [
                              _c("i", {
                                class: _vm.sortReverse
                                  ? "fa fa-sort-asc"
                                  : "fa fa-sort-desc"
                              })
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function($event) {
                            return _vm.sort("rosterService")
                          }
                        }
                      },
                      [
                        _vm._v("\n              Service\n              "),
                        _vm.sortKey === "rosterService"
                          ? _c("span", [
                              _c("i", {
                                class: _vm.sortReverse
                                  ? "fa fa-sort-asc"
                                  : "fa fa-sort-desc"
                              })
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function($event) {
                            return _vm.sort("lastCompletedImportDate")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              Last Completed Import\n              "
                        ),
                        _vm.sortKey === "lastCompletedImportDate"
                          ? _c("span", [
                              _c("i", {
                                class: _vm.sortReverse
                                  ? "fa fa-sort-asc"
                                  : "fa fa-sort-desc"
                              })
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function($event) {
                            return _vm.sort("lastImportDate")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              Latest Import Status\n              "
                        ),
                        _vm.sortKey === "lastImportDate"
                          ? _c("span", [
                              _c("i", {
                                class: _vm.sortReverse
                                  ? "fa fa-sort-asc"
                                  : "fa fa-sort-desc"
                              })
                            ])
                          : _vm._e()
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.sortedDomains, function(domain) {
                      return [
                        _c("tr", { key: domain.uuid }, [
                          _c("td", [
                            _c(
                              "a",
                              {
                                staticClass: "view-link",
                                attrs: { href: `#!/domains/${domain.uuid}` }
                              },
                              [_vm._v(_vm._s(domain.name))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", { staticClass: "service-badge" }, [
                              _vm._v(_vm._s(domain.rosterService))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            domain.lastCompletedImport
                              ? _c(
                                  "div",
                                  { staticClass: "import-status-cell" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getImportLink({
                                            uuid:
                                              domain.lastCompletedImport.uuid,
                                            status:
                                              domain.lastCompletedImport.status,
                                            domain_uuid: domain.uuid
                                          })
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              domain.lastCompletedImport.status
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "timestamp" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            domain.lastCompletedImport
                                              .created_at
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _c("span", [_vm._v("-")])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            domain.lastImportUuid
                              ? _c(
                                  "div",
                                  { staticClass: "import-status-cell" },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getImportLink({
                                                uuid: domain.lastImportUuid,
                                                status: domain.lastImportStatus,
                                                domain_uuid: domain.uuid
                                              })
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  domain.lastImportStatus
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "tooltip",
                                          {
                                            attrs: {
                                              text:
                                                "Preprocessing guardrails detected for this import. Click to view details."
                                            }
                                          },
                                          [
                                            domain.guardrails &&
                                            domain.guardrails.length > 0
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "guardrail-indicator",
                                                    attrs: {
                                                      type: "button",
                                                      "aria-expanded": _vm.isGuardrailsExpanded(
                                                        domain.uuid
                                                      ),
                                                      "aria-controls": _vm.isGuardrailsExpanded(
                                                        domain.uuid
                                                      )
                                                        ? `guardrail-details-${domain.uuid}`
                                                        : null,
                                                      "aria-label": `${
                                                        _vm.isGuardrailsExpanded(
                                                          domain.uuid
                                                        )
                                                          ? "Hide"
                                                          : "Show"
                                                      } ${
                                                        domain.guardrails.length
                                                      } preprocessing guardrails for ${
                                                        domain.name
                                                      }`
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleRow(
                                                          domain.uuid,
                                                          "guardrails"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-exclamation-triangle",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          domain.guardrails
                                                            .length
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "timestamp" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(domain.lastImportDate)
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _c("span", [_vm._v("-")])
                          ])
                        ]),
                        _vm._v(" "),
                        domain.guardrails &&
                        domain.guardrails.length > 0 &&
                        _vm.isGuardrailsExpanded(domain.uuid)
                          ? _c(
                              "tr",
                              {
                                key: `${domain.uuid}-guardrail-details`,
                                staticClass: "guardrail-details-row",
                                attrs: {
                                  id: `guardrail-details-${domain.uuid}`
                                }
                              },
                              [
                                _c(
                                  "td",
                                  { attrs: { colspan: "4" } },
                                  [
                                    _c("guardrail-details", {
                                      attrs: { guardrails: domain.guardrails }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }